import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  consultants: undefined,
  kpiList: [],
  newCampaignKpiSidebar: {
    id: undefined,
    visible: false,
    saveAction: undefined,
  },
  campaigns: [],
}

export default {
  state,
  actions,
  getters,
  mutations
}
